import React from "react";
import { Modal } from "react-bootstrap";
import { Calendar } from "lucide-react";
import { useForm } from "react-hook-form";
import { HrmFormInput } from "../components/hrm_input";
import { updateMetaInfoValidation } from "../../validations/meta_info_validation";
import { useMeta } from "../../contexts";
import { yupResolver } from "@hookform/resolvers/yup";
import { updateUserValidation } from "../../validations/userValidation";

const EditUserModal = ({
  onClose,
  isMetaInfoEditFormVisible,
  initialValues = null
}) => {
  // const data = rowValues;
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors }
  } = useForm({ defaultValues: initialValues, resolver: yupResolver(updateUserValidation) });

  const { onUpdateMetaInfo, metaLoader } = useMeta();
  const onSubmit = async (values) => {
    let request = {
      user_id: values?.id,
      role: "sub_admin",
      name: values?.name,
      email: values?.email,
      password: values?.password,
    };
    await onUpdateMetaInfo(request);
    onClose();
  }

  const handleReset = () => {
    reset();
  }

  return (
    <Modal
      show={isMetaInfoEditFormVisible}
      onHide={onClose}
      size={"md"}
      className="custom-modal"
      centered
    >
      <Modal.Header>
        <Modal.Title className="text-center">
          <h5 className="text-xl font-semibold flex gap-2 items-center text-gray-800">
            Edit User Details
          </h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="space-y-4 p-6">
        <form onSubmit={handleSubmit(onSubmit)}>
          <HrmFormInput label={"Name"} error={errors?.name ? errors.name.message : ""} {...register("name")} />
          <HrmFormInput label={"Email"} type="textarea" error={errors?.email ? errors.email.message : ""} {...register("email")} />
          <HrmFormInput label={"Password"} type="textarea" error={errors?.password ? errors.password.message : ""} {...register("password")} />
          <button type="submit" className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">Update</button>
        </form>
      </Modal.Body>
    </Modal>
  )
}

export default EditUserModal;